import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { trigger, transition, style, animate } from "@angular/animations";
import { ToasService } from "../service/toas-service.service";
import { ToastInsideConfig, PositionToast, ToastPositions } from "../toast.config";
import { ToastAlertComponent } from "../toast-alert.component";
import { IconComponent } from "../../icon/icon.component";

@Component({
  selector: 'mg-toast-group',
  templateUrl: './toast-group.component.html',
  styleUrls: ['./toast-group.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ToastAlertComponent,
    IconComponent
  ],
  animations: [
    trigger('fadeButton', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ToastGroupComponent implements OnInit {
  allToast: { [key: string]: ToastInsideConfig[] } = {
    'top-r': [],
    'top-l': [],
    'bottom-r': [],
    'bottom-l': []
  };

  toastPositions: { [key: string]: PositionToast } = ToastPositions;
  isSmallScreen: boolean = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 740;
  showCloseButton: boolean = false;

  private toastQueue: ToastInsideConfig[] = [];
  private isQueueProcessing: boolean = false;

  constructor(private _toastService: ToasService) {}

  ngOnInit(): void {
    this._toastService.toastObs.subscribe({
      next: (response) => this.addToQueue(Object.values(response))
    });
  }

  private updateCloseButtonVisibility() {
    const hasToasts = Object.values(this.allToast).some(arr => arr.length > 0);
    if (hasToasts && !this.showCloseButton) {
      this.showCloseButton = true;
    } else if (!hasToasts && this.showCloseButton) {
      this.showCloseButton = false;
    }
  }

    async closeAllNotifications() {
      this.toastQueue = [];          
      this.isQueueProcessing = false; 
      this.startFadeOutButton();
      this._toastService.closeAllToast();
      this.clearAllToasts();
    }


    

  private startFadeOutButton() {
    this.showCloseButton = false;
  }

  private clearAllToasts() {
    for (const key in this.allToast) {
      this.allToast[key] = [];
    }
  }

  private async addToQueue(toasts: ToastInsideConfig[]) {
    toasts.forEach(t => {
      const existsInQueue = this.toastQueue.findIndex(i => i.count === t.count);
      const existsInAll = this.allToast[t.position!].findIndex(i => i.count === t.count);
      if (existsInQueue > -1) {
        this.toastQueue[existsInQueue] = t;
      } else if (existsInAll === -1) {
        this.toastQueue.push(t);
      } else {
        this.handleCloseToast(t);
      }
    });

    if (!this.isQueueProcessing) this.processQueue();
  }

  private async processQueue() {
    if (this.toastQueue.length > 0) {
      this.isQueueProcessing = true;
      const toast = this.toastQueue.shift()!;
      this.initHandleToast(toast);
      setTimeout(() => this.processQueue(), 50);
    } else {
      this.isQueueProcessing = false;
    }
  }

  private initHandleToast(toast: ToastInsideConfig) {
    if (!toast.bMostrar) return; 
    if (!this.allToast[toast.position!].some(x => x.count === toast.count)) {
      this.allToast[toast.position!].push(toast);
      this.updateCloseButtonVisibility();
    }
  }


  private async handleCloseToast(data: ToastInsideConfig) {
    if (!data.bMostrar) {
      const totalVisible = Object.values(this.allToast).reduce((sum, arr) => sum + arr.length, 0);
      if (totalVisible === 1) {
        this.startFadeOutButton();
      }
      await this._toastService.deleteToast(data);

      setTimeout(() => {
        this.allToast[data.position!] = this.allToast[data.position!].filter(t => t.count !== data.count);
        this.updateCloseButtonVisibility();
      }, 500);
    }
  }
}
